import {createContext} from 'react'

export const DopamineTableContext = createContext({
  question: '',
  isUpdating: false,
})

export const DopamineTableNavigationContext = createContext<
  (() => void) | undefined
>(undefined)
